<template>
    <div class="main">
        <CatchError>
            <div>
                <transition name="fade-up">
                    <div class="search-panel__result-header"  v-if="totalResultCount > 0">
                        <h3 class="search-panel__result-title">{{ title }}</h3>
                        <Sorting />
                    </div>
                </transition>
            </div>

            <ResultTab v-if="totalResultCount > 0"
                v-for="tab in tabs"
                :tab="tab"
                @pageChanged="$emit('pageChanged')"
            />
            <div v-else class="reading">
                <h3>{{ noResultTitle }}</h3>
                <p v-html="noResultBody"></p>
            </div>
        </CatchError>
    </div>
</template>
<script>
import CatchError from '../Status/CatchError'
import CatchPending from '../Status/CatchPending'
import ResultTab from '../Result/ResultTab'
import Sorting from '../Sorting/Sorting'

import {useStore} from "vuex";
import {computed, ref} from 'vue'

export default {
    name: 'MainView',
    components: {
        CatchError,
        ResultTab,
        CatchPending,
        Sorting,
    },
    setup() {
        const store = useStore()
        const title = computed(() => store.getters.resultTitle)
        const tabs = computed(() => store.getters.tabs)
        const noResultTitle = computed(() => store.getters.data?.copy?.title_no_result)
        const noResultBody = computed(() => store.getters.data?.copy?.body_no_result)
        const totalResultCount = computed(() => store.getters.data?.pagination?.totalCount)
        const animate = ref(null);

        return {
            tabs,
            title,
            totalResultCount,
            noResultTitle,
            noResultBody,
            animate
        }
    }
}
</script>